import React, { useEffect, useState } from "react";
import { Button, Col, Form, Input, Layout, Row, Table, Typography, message } from "antd";
import {
    getQbccManagements,
    createQbccManagement,
    updateQbccManagement,
    deleteQbccManagement
} from "../../actions/qbcc-management.action";
import { isValid } from "../../utils/utilities";
import { showConfirm } from "../../components/custom-components/custom-component";

const { Title } = Typography;
const { Content, Footer } = Layout;

export const QbccConfigPage = () => {

    const [form] = Form.useForm();
    const [qbccUsers, setQbccUsers] = useState([]);
    const [loading, setLoading] = useState(false);
    const [addLoading, setAddLoading] = useState(false);
    const [updateLoading, setUpdateLoading] = useState(false);
    const [deleteLoading, setDeleteLoading] = useState(false);
    const [selectedRow, setSelectedRow] = useState({});

    const fetchQbccUsers = () => {
        setLoading(true);
        getQbccManagements(
            (data) => {
                setQbccUsers(Array.isArray(data) ? data : []);
                setLoading(false);
            },
            (errMsg) => {
                setLoading(false);
                message.error(errMsg);
            }
        );
    };

    useEffect(() => {
        fetchQbccUsers();
    }, []);

    useEffect(() => {
        if (isValid(selectedRow) && isValid(selectedRow.id)) {
            form.setFieldsValue({
                phoneNumber: selectedRow.phone_number,
                name: selectedRow.name
            });
        } else {
            form.resetFields();
        }
    }, [selectedRow]);

    const onSuccess = (msg) => {
        if (isValid(msg)) {
            message.success(msg);
        }
        setAddLoading(false);
        setUpdateLoading(false);
        setDeleteLoading(false);
        setSelectedRow({});
        form.resetFields();
        fetchQbccUsers();
    };

    const onFailure = (errMsg) => {
        setAddLoading(false);
        setUpdateLoading(false);
        setDeleteLoading(false);
        message.error(errMsg);
    };

    const handleSubmit = (buttonType) => {
        form.validateFields()
            .then((values) => {
                const { phoneNumber, name } = values;
                if (buttonType === "add") {
                    setAddLoading(true);
                    createQbccManagement({ phoneNumber, name }, onSuccess, onFailure);
                } else {
                    setUpdateLoading(true);
                    updateQbccManagement({
                        travelManagementId: selectedRow.id,
                        phoneNumber,
                        name
                    }, onSuccess, onFailure);
                }
            })
            .catch((errorInfo) => {
                console.log({ errorInfo });
            });
    };

    const onDelete = () => {
        setDeleteLoading(true);
        deleteQbccManagement({ travelManagementId: selectedRow.id }, onSuccess, onFailure);
    };

    const columns = [
        {
            title: "Phone number",
            dataIndex: "phone_number"
        },
        {
            title: "Name",
            dataIndex: "name"
        }
    ];

    return (
        <div className="qbcc-config-page" style={{ margin: "20px" }}>
            <Title level={4}>QBCC Config</Title>
            <Table
                dataSource={qbccUsers}
                columns={columns}
                loading={loading}
                pagination={{ pageSize: 10 }}
                rowKey={(record) => record.id}
                rowClassName={(record) => record.id === selectedRow.id ? "TableRowClicked" : ""}
                onRow={(record) => ({
                    onClick: () => {
                        setSelectedRow(record);
                    }
                })}
            />
            <Layout style={{ marginTop: "20px", background: "transparent" }}>
                <Title level={4}>QBCC User Form</Title>
                <Content>
                    <Form layout="inline" form={form} name="qbcc-form" initialValues={{}}>
                        <Form.Item
                            label="Phone number"
                            name="phoneNumber"
                            rules={[{ required: true, message: "Please input phone number!" }]}
                        >
                            <Input placeholder="Phone number" />
                        </Form.Item>
                        <Form.Item
                            label="Name"
                            name="name"
                            rules={[{ required: false, message: "Please input name!" }]}
                        >
                            <Input placeholder="Name" />
                        </Form.Item>
                    </Form>
                </Content>
                <Footer style={{ background: "transparent", paddingLeft: 0 }}>
                    <Row gutter={[8, 8]}>
                        <Col>
                            <Button
                                loading={addLoading}
                                style={{ background: "#2EC17C", color: "#fff" }}
                                disabled={isValid(selectedRow.id)}
                                onClick={() => handleSubmit("add")}
                            >
                                Add
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                type="primary"
                                loading={updateLoading}
                                disabled={!isValid(selectedRow.id)}
                                onClick={() => handleSubmit("update")}
                            >
                                Update
                            </Button>
                        </Col>
                        <Col>
                            <Button
                                type="danger"
                                loading={deleteLoading}
                                disabled={!isValid(selectedRow.id)}
                                onClick={() => {
                                    showConfirm(onDelete, "Delete QBCC user", "Are you sure?");
                                }}
                            >
                                Delete
                            </Button>
                        </Col>
                        <Col>
                            <Button onClick={() => setSelectedRow({})}>
                                Clear
                            </Button>
                        </Col>
                    </Row>
                </Footer>
            </Layout>
        </div>
    );
};
